function UserUnknown() {
    return (
        <div className="w-full h-full flex flex-1 flex-col items-center justify-center text-2xl font-semibold text-moregrayTextColor">
            Trang này chưa được cập nhật
        </div>
    );
}

export default UserUnknown;